import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditPersonMasterPage = withSuspense(lazy(() => import('./edit-person-master-page')));
export default EditPersonMasterPage;
